<template>
  <div class="flex items-start justify-between border-b pb-4">
    <!-- Left Side: Emergency Contact Form -->
    <div class="w-1/2 pr-4">
      <!-- ADDED: Information note about optional emergency contacts -->
      <div class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
        <p class="text-sm text-blue-800">
          <strong>Note:</strong> Emergency contact information is optional but recommended.
        </p>
      </div>

      <form @submit.prevent class="space-y-6">
        <div class="pb-4 space-y-4">
          <div>
            <!-- REMOVED RED ASTERISK - Emergency contact is now optional -->
            <label class="block text-sm font-bold text-gray-700"
              >Full Name
            </label>
            <input
              v-model="emergencyContact.fullName"
              type="text"
              placeholder="Type..."
              class="mt-1 block w-full rounded-md border-gray-300 bg-gray-50 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 h-12"
            />
          </div>
          <div>
            <!-- REMOVED RED ASTERISK -->
            <label class="block text-sm font-bold text-gray-700"
              >Relationship To Patient</label
            >

            <select
              v-model="emergencyContact.relationship"
              id="patient-title"
              class="w-full px-3 py-2 mt-1 text-sm bg-gray-100 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              required
            >
              <option disabled value="">Select relationship</option>
              <option
                v-for="relationship in relationships"
                :key="relationship"
                :value="relationship"
              >
                {{ relationship }}
              </option>
            </select>
          </div>
          <div>
            <!-- REMOVED RED ASTERISK -->
            <label class="block text-sm font-bold text-gray-700">
              Phone Number</label
            >
            <input
              v-model="emergencyContact.phoneNumber"
              type="text"
              placeholder="E.g 0711222333"
              @input="validatePhone"
              class="mt-1 block w-full rounded-md border-gray-300 bg-gray-50 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 h-12"
            />
            <p v-if="phoneError" class="text-red-500 text-sm mt-1">
              {{ phoneError }}
            </p>
          </div>
        </div>
        <div class="space-x-4">
          <button
            type="button"
            @click="addEmergencyContact"
            class="px-6 mb-4 r-4 py-2 bg-custom-yellow text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
          >
            <span>Add</span>
          </button>
          <button
            type="button"
            @click="clearForm"
            class="px-6 mb-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
          >
            Clear
          </button>
        </div>
      </form>
    </div>

    <!-- Right Side: Add Button -->
    <!-- <div class="w-1/2 flex items-start justify-end pl-4">
            <button @click="addEmergencyContact"
                class="text-custom-yellow hover:text-custom-yellow-dark border-4 border-custom-yellow  p-1">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M12 4v16m8-8H4" />
                </svg>
            </button>
        </div> -->
  </div>

  <!-- Display Added Emergency Contacts in Table Format -->
  <div v-if="existingEmergencyContacts.length" class="mt-6">
    <h3 class="text-lg font-bold text-gray-800 mb-4">
      Added Emergency Contacts
    </h3>
    <table class="w-full bg-white rounded-md shadow-md">
      <thead>
        <tr class="bg-gray-100 border-b">
          <th class="py-2 px-4 text-left text-sm font-medium text-gray-700">
            Full Name
          </th>
          <th class="py-2 px-4 text-left text-sm font-medium text-gray-700">
            Relationship
          </th>
          <th class="py-2 px-4 text-left text-sm font-medium text-gray-700">
            Phone Number
          </th>
          <th class="py-2 px-4 text-left text-sm font-medium text-gray-700">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(contact, index) in existingEmergencyContacts"
          :key="index"
          class="border-b"
        >
          <td class="py-2 px-4">{{ contact.fullName }}</td>
          <td class="py-2 px-4">{{ contact.relationship }}</td>
          <td class="py-2 px-4">{{ contact.phoneNumber }}</td>
          <td class="py-2 px-4 space-x-2">
            <button
              @click="deleteEmergencyContact(index)"
              class="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
            >
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-if="emergencyContacts.length" class="mt-6">
    <h3 class="text-lg font-bold text-gray-800 mb-4">
      Added Emergency Contacts
    </h3>
    <table class="w-full bg-white rounded-md shadow-md">
      <thead>
        <tr class="bg-gray-100 border-b">
          <th class="py-2 px-4 text-left text-sm font-medium text-gray-700">
            Full Name
          </th>
          <th class="py-2 px-4 text-left text-sm font-medium text-gray-700">
            Relationship
          </th>
          <th class="py-2 px-4 text-left text-sm font-medium text-gray-700">
            Phone Number
          </th>
          <th class="py-2 px-4 text-left text-sm font-medium text-gray-700">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(contact, index) in emergencyContacts"
          :key="index"
          class="border-b"
        >
          <td class="py-2 px-4">{{ contact.fullName }}</td>
          <td class="py-2 px-4">{{ contact.relationship }}</td>
          <td class="py-2 px-4">{{ contact.phoneNumber }}</td>
          <td class="py-2 px-4 space-x-2">
            <button
              @click="deleteEmergencyContact(index)"
              class="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
            >
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { validatePhoneNumber } from "@/services/customUtilities";

export default {
  name: "PatientEmergencyContactForm", // Component name
  props: {
    formData: {
      type: Object,
      required: true,
    },
    existingEmergencyContacts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      patientRegForm: { ...this.formData },
      emergencyContact: {
        fullName: "",
        relationship: "",
        phoneNumber: "",
      },
      emergencyContacts: [],
      phoneError: "",
      relationships: [
        "Spouse",
        "Father",
        "Mother",
        "Brother",
        "Sister",
        "Gurdian",
        "Sibling",
        "Friend",
        "Child",
        "Colleague",
        "Other",
      ],
    };
  },
  watch: {
    existingEmergencyContacts(newVal) {
      console.log(newVal);
    },
  },
  methods: {
    updateForm() {
      this.$emit("update:formData", this.patientRegForm);
      console.log(this.patientRegForm); // Emit updated form data to parent
    },
    addEmergencyContact(event) {
      event.preventDefault();

      // UPDATED: Check if at least one field is filled (partial validation)
      // If no fields are filled, we just don't add anything (silent)
      const hasAnyField = this.emergencyContact.fullName ||
                         this.emergencyContact.relationship ||
                         this.emergencyContact.phoneNumber;

      if (!hasAnyField) {
        // All fields are empty - this is okay, just don't add
        return;
      }

      // UPDATED: If user started filling but didn't complete, show specific error
      if (hasAnyField) {
        const missingFields = [];
        if (!this.emergencyContact.fullName) missingFields.push("Full Name");
        if (!this.emergencyContact.relationship) missingFields.push("Relationship");
        if (!this.emergencyContact.phoneNumber) missingFields.push("Phone Number");

        if (missingFields.length > 0) {
          alert(`Please complete the following fields to add emergency contact: ${missingFields.join(", ")}`);
          return;
        }
      }

      // All fields are filled - add the contact
      this.patientRegForm.patient.emergencyContact = this.emergencyContact;
      this.updateForm();
      this.emergencyContacts.push({ ...this.emergencyContact });

      // Reset the form fields for the next entry
      this.emergencyContact = {
        fullName: "",
        relationship: "",
        phoneNumber: "",
      };
    },
    deleteEmergencyContact(index) {
      // Remove the selected contact from the list
      this.emergencyContacts.splice(index, 1);
    },
    clearForm() {
      this.emergencyContact = {
        fullName: "",
        relationship: "",
        phoneNumber: "",
      };
    },
    validatePhone(event) {
      // Remove non-numeric characters
      const numericValue = event.target.value.replace(/\D/g, "");

      this.emergencyContact.phoneNumber = numericValue;

      const result = validatePhoneNumber(this.emergencyContact.phoneNumber);
      // console.log('phone no validation', result);
      if (!result.valid) {
        this.phoneError = result.message;
      } else {
        this.phoneError = null;
      }
    },
  },
};
</script>

<style scoped>
/* Add any additional styles if needed */
</style>